import { FINANCIAL_SUMMARY_RECEIVED, FINANCIAL_SUMMARY_UNLOADED } from './types'
import api from 'api'

export const financialSummaryReceived = (data) => ({
  type: FINANCIAL_SUMMARY_RECEIVED,
  data
})

export const financialSummaryUnload = () => ({
  type: FINANCIAL_SUMMARY_UNLOADED
})

export const getFinancialSummary = (advisor = false) => (dispatch) =>
  api.rnc.getFinancialSummary(advisor).then( data => {
    dispatch(financialSummaryReceived(data))
})

export const unloadFinancialSummary = () => dispatch => {
  dispatch(financialSummaryUnload)
}

